import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./NumbersModal.css";
import {
  AllEquipmentButton,
  CreateEquipmentButton,
  CreateScenarioCommand,
  UpdateScenarioCommand,
} from "../../api/api";
import ErrorToast from "../toasts/ErrorToast";
import MqttManager from "../../mqtt/Base";
import SuccessToast from "../toasts/SuccessToast";
import { useParams } from "react-router-dom";
import { MqttContext } from "../../context/MQTTContext";

const NumbersModal = ({
  type,
  learningModeInTv,
  setLearningModeInTv,
  equip_id,
  closeSelectOutputEquipmentRef,
  closeSelectEquipmentRef,
  setData,
}) => {
  const {
    setNumbersModal,
    handleLearnCodeModal,
    scenarioMode,
    addScenarioCommandDetail,
    scenarioCommandDetail,
    selectedEquipment,
    setButtonShouldLearnCode,
    setbuttons,
    clickTvButton,
    setClickTvButton,
    scenarioCommands,
    setScenarioCommands,
    setIsLoading,
    equipmentButtons,
    devices,
    setEquipmentButtons,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);

  const modalName = useRef(null);
  const [selectedIcon, setSelectedIcon] = useState("");
  const [deviceId, setDeviceId] = useState();
  const [buttons, setButtons] = useState([]);
  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();
  const closeButton = useRef();

  useEffect(() => {
    setNumbersModal(modalName);
  }, []);

  useEffect(() => {
    setButtons(
      equipmentButtons
        .filter((eq_btn) => eq_btn.equipment_id == equip_id)
        .map((btn) => ({
          ...btn,
          digit: btn.digit != null ? Number(btn.digit) : null,
        })),
    );

    const $modal = window.$("#numbersModal"); // ✅ آی‌دی صحیح
    const handleHide = function () {
      if (modalName.current) {
        closeButton.current.click();
      }
    };

    $modal.on("hide.bs.modal", handleHide);

    return () => {
      $modal.off("hide.bs.modal", handleHide);
    };
  }, [equipmentButtons, equip_id]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleClickButton = (digit, icon) => {
    if (type == 3) {
      getButtonDataScheduleMode(digit, icon);
    }
    if (scenarioMode && type == 2) {
      getButtonDataScenarioMode(digit, icon);
    } else if (type == 1) {
      let button = buttons.find((b) => b.digit == digit);
      if (
        button &&
        button.data1 &&
        button.data2 &&
        button.data3 &&
        button.data4 &&
        button.data5 &&
        !learningModeInTv
      ) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        if (!device) {
          return ErrorToast("دستگاه ناشناخته می باشد");
        }
        if (device.is_bus == 1) {
          if (!clients[device.bridge_device.id]) return;
          setClickTvButton(true);
          let buffer = new ArrayBuffer(15);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 1;
          asciiCode[9] = 5;
          asciiCode[10] = button.data1;
          asciiCode[11] = button.data2;
          asciiCode[12] = button.data3;
          asciiCode[13] = button.data4;
          asciiCode[14] = button.data5;

          let message = device.bridge_device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.bridge_device.id].on("message", (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              message[10] == 1 &&
              message[2] == 14
            ) {
              setClickTvButton(false);
            }
          });

          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
        } else {
          if (!clients[device.id]) return;

          setClickTvButton(true);
          let buffer = new ArrayBuffer(7);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 1;
          asciiCode[1] = 5;
          asciiCode[2] = button.data1;
          asciiCode[3] = button.data2;
          asciiCode[4] = button.data3;
          asciiCode[5] = button.data4;
          asciiCode[6] = button.data5;

          let message = device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.id].on("message", (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              message[2] == 1 &&
              message[3] == 0
            ) {
              setClickTvButton(false);
            }
          });

          clients[device.id].publish(device.serial + "/sys", combinedMessage);
        }
      } else {
        setIsLoading(true);
        CreateEquipmentButton({
          equipment_id: equip_id,
          device_id: buttons[0].device_id,
          digit,
          type: 100,
        }).then(({ data }) => {
          setEquipmentButtons((prev) => [
            ...prev,
            {
              id: data.equipment_button
                ? data.equipment_button.id
                : data.equipment_buttons[0].id,
              equipment_id: equip_id,
              device_id: buttons[0].device_id,
              digit: digit,
              type: 100,
              data1: null,
              data2: null,
              data3: null,
              data4: null,
              data5: null,
            },
          ]);
          setButtonShouldLearnCode(data.equipment_button);
          handleLearnCodeModal(true);
          setIsLoading(false);
          setLearningModeInTv(false);
        });
      }
    }
  };

  const getButtonDataScenarioMode = (digit, icon) => {
    let button = equipmentButtons.find(
      (eq_btn) => eq_btn.equipment_id == equip_id && eq_btn.digit == digit,
    );
    if (button) {
      if (scenarioCommandDetail.id) {
        setScenarioCommands((prevCommands) =>
          scenarioCommands.map((command) =>
            command.id == scenarioCommandDetail.id
              ? {
                  ...command,
                  device_id: button.device_id,
                  time: scenarioCommandDetail.time,
                  data1: 5,
                  data2: button.data1,
                  data3: button.data2,
                  data4: button.data3,
                  data5: button.data4,
                  data6: button.data5,
                  data7: null,
                  data8: null,
                  data9: null,
                  data10: null,
                  data11: null,
                  command_name: "",
                  icon: button.icon ?? icon,
                }
              : command,
          ),
        );
      } else {
        setScenarioCommands((prev) => [
          ...prev,
          {
            id: scenarioCommands.length + 1,
            scenario_id: addScenarioCommandDetail.scenario_id,
            data1: 5,
            data2: button.data1,
            data3: button.data2,
            data4: button.data3,
            data5: button.data4,
            data6: button.data5,
            data7: null,
            data8: null,
            data9: null,
            data10: null,
            data11: null,
            command_name: "",
            icon: button.icon ?? icon,
            device_id: button.device_id,
            time: 500,
          },
        ]);
      }
      closeButton.current.click();
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    } else {
      ErrorToast("کلید تعریف نشده است");
    }
  };

  const getButtonDataScheduleMode = (digit, icon) => {
    let button = equipmentButtons.find(
      (eq_btn) => eq_btn.equipment_id == equip_id && eq_btn.digit == digit,
    );
    if (button) {
      const device = devices.find((d) => d.id == button.device_id);
      setData({
        icon,
        name: null,
        data: [
          2,
          5,
          button.data1,
          button.data2,
          button.data3,
          button.data4,
          button.data5,
        ],
        device: device,
      });

      closeButton.current.click();
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    } else {
      ErrorToast("کلید تعریف نشده است");
    }
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="numbersModal"
      tabIndex="-1"
      aria-labelledby="numbersModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="number-keys d-flex justify-content-around mb-4">
              <div onClick={(status) => handleClickButton(102, 48)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 102 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/6n-on.png"
                      : "/assets/img/app-icons/6n.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(101, 49)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 101 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/KH-on.png"
                      : "/assets/img/app-icons/KH.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(100, 50)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 100 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/an-on.png"
                      : "/assets/img/app-icons/an.png"
                  }
                />
              </div>
            </div>
            <div className="number-keys d-flex justify-content-around mb-4">
              <div onClick={(status) => handleClickButton(105, 51)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 105 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/KG-on.png"
                      : "/assets/img/app-icons/KG.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(104, 52)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 104 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/am-on.png"
                      : "/assets/img/app-icons/am.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(103, 53)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 103 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/am-on.png"
                      : "/assets/img/app-icons/am.png"
                  }
                />
              </div>
            </div>
            <div className="number-keys d-flex justify-content-around mb-4">
              <div onClick={(status) => handleClickButton(108, 54)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 108 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/ap-on.png"
                      : "/assets/img/app-icons/ap.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(107, 55)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 107 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/qG-on.png"
                      : "/assets/img/app-icons/qG.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(106, 56)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 106 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/6m-on.png"
                      : "/assets/img/app-icons/6m.png"
                  }
                />
              </div>
            </div>
            <div className="number-keys d-flex justify-content-around mb-4">
              <div onClick={(status) => handleClickButton(111, 57)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 111 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/0t-on.png"
                      : "/assets/img/app-icons/0t.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(110, 58)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 110 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/qE-on.png"
                      : "/assets/img/app-icons/qE.png"
                  }
                />
              </div>
              <div onClick={(status) => handleClickButton(109, 59)}>
                <img
                  src={
                    buttons.some(
                      (button) =>
                        button.digit == 109 &&
                        button.data1 &&
                        button.data2 &&
                        button.data3 &&
                        button.data4 &&
                        button.data5,
                    )
                      ? "/assets/img/app-icons/rdy-on.png"
                      : "/assets/img/app-icons/rdy.png"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumbersModal;
